import { render, staticRenderFns } from "./BusinessKeywords.vue?vue&type=template&id=16369c79&scoped=true&"
import script from "./BusinessKeywords.vue?vue&type=script&lang=ts&"
export * from "./BusinessKeywords.vue?vue&type=script&lang=ts&"
import style0 from "./BusinessKeywords.vue?vue&type=style&index=0&id=16369c79&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16369c79",
  null
  
)

export default component.exports